import type { ReactElement } from "react";
import { useEffect, useRef, useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Textfield } from "@similarweb/ui-components";

import { columnsSelectionTrackingService } from "../../columnsSelectionTrackingService";

import { ColumnSearchFieldContainer } from "./styles";

type ColumnSearchFieldProps = {
    value: string;
    onChange: (value: string) => void;
};

export const ColumnSearchField = (props: ColumnSearchFieldProps): ReactElement => {
    const { translate } = useTranslate();
    const searchPlaceholder = translate("si.common.search");

    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (textFieldRef.current?.getValue() !== props.value) {
            textFieldRef.current?.setValue(props.value);
        }
    }, [props.value]);

    const textFieldRef = useRef<Textfield>(null);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleTextFieldChange = (value: string) => {
        columnsSelectionTrackingService.trackSearch(value);
        props.onChange(value);
    };

    return (
        <ColumnSearchFieldContainer focused={isFocused}>
            <Textfield
                ref={textFieldRef}
                iconName="search"
                onChange={handleTextFieldChange}
                placeholder={searchPlaceholder}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
        </ColumnSearchFieldContainer>
    );
};
